import React, { useContext } from "react";

export interface MediaQueryContextValue {
  useIsXs: () => boolean;
  useIsSm: () => boolean;
  useIsMd: () => boolean;
  useIsLg: () => boolean;
  useIsXl: () => boolean;
  useIs2xl: () => boolean;
}

export const MediaQueryContext = React.createContext<MediaQueryContextValue>(
  null as any
);

export const useBreakPoints = (): MediaQueryContextValue => {
  return useContext(MediaQueryContext);
};
